import React from 'react'

interface IGroupDetail {
  id: string | null;
}

const GroupDetail = ({ id }: IGroupDetail) => {
  return (
    <div>GroupDetail</div>
  )
}

export default GroupDetail